import { formatTestId } from '../../util/EfupUtility';

export const ValidatedInput = (props) => {
    const {label, errorKey, value, validator, valueSetter, onChange, formName, errors,  maxLength, regex, onFocus, isTextBox, readOnly} = props;
    const testId = formatTestId(`${formName}-${label}`)

    function handleInputChange(newInput) {
        onChange(errorKey, newInput, valueSetter, validator, regex)
    }

    function handleInputFocus() {
        if (onFocus) {
            onFocus();
        }
    } 

    return(
        <div className="payment-search-disbursement-uuid cb-form-group" >
            <label className="cb-form-control-label fieldLabel" data-testid={testId + '-label'}>{label}</label>
            {isTextBox? 
                <textarea className={"cb-form-control " + (errors ? 'cb-input-error' : '') }
                    type="text" 
                    value={value} 
                    rows={5}
                    maxLength={maxLength}
                    readOnly={readOnly}
                    data-testid={testId + '-input'}
                    onChange={e => handleInputChange(e.target.value)}
                    onFocus={handleInputFocus}
                />:
                <input className={"cb-form-control " + (errors ? 'cb-input-error' : '') }
                    type="text" 
                    value={value} 
                    maxLength={maxLength}
                    readOnly={readOnly}
                    data-testid={testId + '-input'}
                    onChange={e => handleInputChange(e.target.value)}
                    onFocus={handleInputFocus}
                />
            }
            {errors && (
                <div className="cb-input-error" data-testid={testId + '-errors'}>{errors}</div>
            )}
        </div>
    )
}